export const subTotal = (subs = []) => subs.reduce((a, s) => a + Number(s.duration_minutes || 0), 0);
export const taskTotal = (t) => subTotal(t.subtasks) || Number(t.duration_minutes || 0);
export const blankSub = () => ({ title: "", duration_minutes: 15, sop_link: "", template_link: "", done: false });
export const blankTask = (assignee_id) => ({ title: "", role: "", description: "", duration_minutes: 30, sets_status: "", subtasks: [blankSub()], ...(assignee_id ? { assignee_id } : {}) });
export const href = (link) => (/^https?:\/\//i.test(link) ? link : `https://${link}`);

export const cleanTask = (t) => ({
  ...t, role: t.role || "", sets_status: t.sets_status || "", duration_minutes: taskTotal(t) || 30,
  subtasks: (t.subtasks || []).filter((s) => s.title.trim()).map((s) => ({ ...s, duration_minutes: Number(s.duration_minutes || 0) })),
});
